import { PatientGender } from "./messages/Visit";
import { STRINGS } from "./strings";
import { translate } from "./translate";

export function formatCompletionRatio(ratio: number) {
  const percents = (ratio * 100).toFixed(0);

  return `${percents}% ${translate(STRINGS.COMPLETED)}`;
}

export function formatPatientGender(patientGender: PatientGender | null) {
  switch (patientGender) {
    case "M":
      return translate(STRINGS.MALE);
    case "F":
      return translate(STRINGS.FEMALE);
    default:
      return "";
  }
}

export function formatPatientInitials(patientInitials: string) {
  return patientInitials.replaceAll(".", "").replace(" ", "");
}

export function emptyStringOrUndefinedToDefault<T>(
  val: string | null | undefined,
  defaultValue: T
) {
  return val === null || val === undefined || val.trim() === "" ? defaultValue : val;
}
